import script from "./FoundsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FoundsModal.vue?vue&type=script&setup=true&lang=js"

import "./FoundsModal.vue?vue&type=style&index=0&id=2351fa53&lang=scss"

const __exports__ = script;

export default __exports__